<template>
  <hr class="ace-divider" />
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.ace-divider {
  border-color: #707070;

  margin: 45px auto;
  max-width: 620px;
}
</style>
